<template>
  <div>
      <vue-navigation-bar :options="navbarData" >
      </vue-navigation-bar>
      <dashboard-content> </dashboard-content>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
  </div>
</template>
<script>
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'

export default {
  components: {
    DashboardContent,
    ContentFooter
  },
  data () {
    return {
      navbarData: {
        elementId: 'main-navbar',
        isUsingVueRouter: true,
        mobileBreakpoint: 992,
        brandImagePath: '/dashboard',
        brandImage: require('@/assets/img/favicon.png'),
        brandImageAltText: 'vue-navigation-bar',
        collapseButtonStyle: 'dark',
        ariaLabelMainNav: 'Main Navigation',
        menuOptionsLeft: [
          {
            type: 'link',
            text: this.$i18n.t('Main'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('Customers'),
                path: '/users'
              },
              {
                type: 'link',
                text: this.$i18n.t('System users'),
                path: '/systemusers'
              },
              {
                type: 'link',
                text: this.$i18n.t('Accounts'),
                path: '/accounts'
              },
              {
                type: 'link',
                text: this.$i18n.t('Card pools'),
                path: '/cardpools'
              },
              {
                type: 'link',
                text: this.$i18n.t('Groups'),
                path: '/groups'
              },
              {
                type: 'link',
                text: this.$i18n.t('System groups'),
                path: '/systemGroups'
              },
              {
                type: 'link',
                text: this.$i18n.t('IP groups'),
                path: '/ipgroups'
              },
              {
                type: 'link',
                text: this.$i18n.t('Telephone numbers'),
                path: '/telephonenum'
              }
            ]
          },
          {
            type: 'link',
            text: this.$i18n.t('Tariffication'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('Services/Tariff'),
                path: '/ServicesAndTariffsTarifficationTab/ServicesTariffication'
              },
              {
                type: 'link',
                text: this.$i18n.t('Telephony settings'),
                path: '/TelephoneTarifficationTab/TelephoneTarifficationZones'
              },
              {
                type: 'link',
                text: this.$i18n.t('AdditionalParam'),
                path: '/TarifficationAdditional/TarifficationAdditionalAccountingPeriods'
              },
              {
                type: 'link',
                text: this.$i18n.t('Other'),
                path: '/OtherTarifficationTab/OtherTarifficationContractType'
              }
            ]
          },
          {
            type: 'link',
            text: this.$i18n.t('Reference book'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('Payments methods'),
                path: '/paymentsMethods'
              },
              {
                type: 'link',
                text: this.$i18n.t('Сurrency'),
                path: '/currency'
              },
              {
                type: 'link',
                text: this.$i18n.t('IP zone'),
                path: '/ipZone'
              },
              {
                type: 'link',
                text: this.$i18n.t('Buildings'),
                path: '/buildings'
              },
              {
                type: 'link',
                text: this.$i18n.t('Streets'),
                path: '/streets'
              },
              {
                type: 'link',
                text: this.$i18n.t('Banks'),
                path: '/banks'
              },
              {
                type: 'link',
                text: this.$i18n.t('Companies'),
                path: '/companies'
              }
            ]
          },
          {
            type: 'link',
            text: this.$i18n.t('Reports'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('Payments'),
                path: '/ReportsPayments/ReportsPaymentsPayments'
              },
              {
                type: 'link',
                text: this.$i18n.t('Services'),
                path: '/ReportsServices/ReportsServicesGeneral'
              },
              {
                type: 'link',
                text: this.$i18n.t('OtherReport'),
                path: '/ReportsOther/ReportsOtherBlocking'
              }
            ]
          },
          {
            type: 'link',
            text: this.$i18n.t('Inventory'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('Profiles'),
                path: '/inventoryProfiles'
              },
              {
                type: 'link',
                text: this.$i18n.t('Switches'),
                path: '/inventorySwitches'
              },
              {
                type: 'link',
                text: this.$i18n.t('DHCPv4 pools'),
                path: '/InventoryDhcpPools'
              },
              {
                type: 'link',
                text: this.$i18n.t('DHCPv4 leases'),
                path: '/InventoryDhcpLeases'
              }
            ]
          },
          {
            type: 'link',
            text: this.$i18n.t('Settings'),
            path: '/',
            subMenuOptions: [
              {
                type: 'link',
                text: this.$i18n.t('TelephonyReports'),
                path: '/telephony/emergencyCalls'
              },
              {
                type: 'link',
                text: this.$i18n.t('Documents'),
                path: '/documents/documentTemplates'
              },
              {
                type: 'link',
                text: this.$i18n.t('Systems'),
                path: '/system/SettingsSystem'
              },
              {
                type: 'link',
                text: this.$i18n.t('Inventory'),
                path: '/inventory/netFlowproviders'
              },
              {
                type: 'link',
                text: 'ISG',
                path: '/ISG/ISGattributes'
              },
              {
                type: 'link',
                text: 'DHCPv6',
                path: '/DHCPv6/mainDHCPv6'
              },
              {
                type: 'link',
                text: this.$i18n.t('Customer portal'),
                path: '/CustomerPortal/SettingsSwitchTariff'
              }
            ]
          }
        ],
        menuOptionsRight: [
          {
            type: 'button',
            text: this.$i18n.t('Logout'),
            path: '/logout',
            class: 'button-red'
          }
        ]
      },
      collapseImage: require('@/assets/img/arrow_state_grey_right.png'),
      is_dev: process.env.NODE_ENV === 'development'
    }
  },
  methods: {
    logout: function () {
      this.$cookie.delete('session_id')
      this.$router.push('login')
    }
  }
}
</script>

<style>
.vnb .button-red {
  background: #dc3545;
  color: white !important;
}
.vnb .button-red:hover {
  background: #bd2130;
}
.vnb__menu-options__option__link {
  color: black !important;
}
.vnb__sub-menu-options__option__link__text-wrapper__text {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/DashboardLayout.vue